<i class="far fa-window-close" data-fa-symbol="window-close"></i>
<i class="fas fa-flag" data-fa-symbol="fas-flag"></i>
<i class="far fa-flag" data-fa-symbol="far-flag"></i>
<i class="far fa-info" data-fa-symbol="info"></i>
<i class="far fa-crosshairs" data-fa-symbol="crosshair"></i>
<i class="far fa-chart-area" data-fa-symbol="chart-area"></i>
<i class="far fa-train" data-fa-symbol="train"></i>
<i class="far fa-sticky-note" data-fa-symbol="sticky"></i>
<i class="far fa-sync-alt" data-fa-symbol="sync-alt" [attr.data-fa-transform]="''"></i>
<i class="far fa-plus" data-fa-symbol="new"></i>


<qm-overlay-panel #hoverOverlay [stickTo]="'left-bottom'" [appendTo]="'body'" [skipFirstClick]="false" (onBeforeHide)="beforeHoverHide()">
  <div class="card hover-container" *ngIf="selectedFeature?.properties" [style.background-color]="getColor()">
    <div class="card-header">
      {{getTitle()}}
      <a [attr.data-btnId]="getElementId('hide')" class="float-right" (click)="hoverOverlay.hide()">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#window-close"></use>
        </svg>
      </a>
    </div>
    <div class="card-body">
      <ng-container [ngSwitch]="selectedFeature.layer.metadata.hoverComponent">
        <ng-container *ngSwitchCase="'ElementDetailsHover'">
          <qm-element-hover [selectedFeature]="selectedFeature"></qm-element-hover>
          <div class="link-list" *qmAuth="'objectdescription-read'">
            <div *ngIf="selectedFeature?.properties">
              <qm-element-text [selectedFeature]="selectedFeature"></qm-element-text>
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="'TrainHover'">
          <span *ngIf="selectedFeature?.properties?.vak" class="vak-thumb">VAK</span>
          <qm-train-hover [selectedFeature]="selectedFeature"></qm-train-hover>
        </ng-container>

        <ng-container *ngSwitchCase="'FluentHover'">
          <qm-fluent-hover [selectedFeature]="selectedFeature"></qm-fluent-hover>
        </ng-container>

      </ng-container>
      <div class="alarm-list" *ngIf="alarms.length > 0">
        <hr class="hover-divider">
        <div class="header">
          {{'Alarms' | translate}}
        </div>
        <div class="d-flex flex-column justify-content-between" *ngFor="let alarm of alarms">
          <span>{{getAlarmMessage | applyFunction:alarm}}</span>
        </div>
      </div>
      <hr class="hover-divider" [style.marginBottom]="0" />
    </div>
    <div class="card-footer">
      <qm-element-actions
        [visibleButtons]="{
          info: !!this.selectedFeature.layer.metadata.component,
          flag: true,
          focus: true,
          follow: true,
          cargoManifest: this.selectedFeature.layer.id === 'T'
        }"
        [qmStyle]="{padding: '0.55em 0', margin: '0 0.45rem'}"
        [selectedFeature]="selectedFeature"
        [selectedLayer]="selectedFeature.layer"
        (detailsOpened)="ignoreNextHoverHide = true; hoverOverlay.hide()">
      </qm-element-actions>
    </div>
  </div>
</qm-overlay-panel>
